module.exports = "/_next/static/images/486d4b13e8f23a5f3c3c86e6a629cc2d-2-women-working-landscape@0.5x.jpg";